'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _clientLibrary = require('@seneca/client-library');

var _Draft = require('./models/Draft');

var _Draft2 = _interopRequireDefault(_Draft);

var _CourseDetails = require('./models/CourseDetails');

var _CourseDetails2 = _interopRequireDefault(_CourseDetails);

var _SectionDetails = require('./models/SectionDetails');

var _SectionDetails2 = _interopRequireDefault(_SectionDetails);

var _CourseEnrollment = require('./models/CourseEnrollment');

var _CourseEnrollment2 = _interopRequireDefault(_CourseEnrollment);

var _CourseEnrollmentsPage = require('./models/CourseEnrollmentsPage');

var _CourseEnrollmentsPage2 = _interopRequireDefault(_CourseEnrollmentsPage);

var _DraftDoesNotExistError = require('./errors/DraftDoesNotExistError');

var _DraftDoesNotExistError2 = _interopRequireDefault(_DraftDoesNotExistError);

var _CourseDoesNotExistError = require('./errors/CourseDoesNotExistError');

var _CourseDoesNotExistError2 = _interopRequireDefault(_CourseDoesNotExistError);

var _SubscriptionNotFoundError = require('./errors/SubscriptionNotFoundError');

var _SubscriptionNotFoundError2 = _interopRequireDefault(_SubscriptionNotFoundError);

var _SubscriptionNotActiveError = require('./errors/SubscriptionNotActiveError');

var _SubscriptionNotActiveError2 = _interopRequireDefault(_SubscriptionNotActiveError);

var _SubscriptionNotValidError = require('./errors/SubscriptionNotValidError');

var _SubscriptionNotValidError2 = _interopRequireDefault(_SubscriptionNotValidError);

var _PublishingErrors = require('./errors/PublishingErrors');

var _PublishingErrors2 = _interopRequireDefault(_PublishingErrors);

var _DraftObjectDoesNotExistError = require('./errors/DraftObjectDoesNotExistError');

var _DraftObjectDoesNotExistError2 = _interopRequireDefault(_DraftObjectDoesNotExistError);

var _DraftObjectConflictError = require('./errors/DraftObjectConflictError');

var _DraftObjectConflictError2 = _interopRequireDefault(_DraftObjectConflictError);

var _DraftBodyNotValidError = require('./errors/DraftBodyNotValidError');

var _DraftBodyNotValidError2 = _interopRequireDefault(_DraftBodyNotValidError);

var _CourseEnrollmentBodyNotValidError = require('./errors/CourseEnrollmentBodyNotValidError');

var _CourseEnrollmentBodyNotValidError2 = _interopRequireDefault(_CourseEnrollmentBodyNotValidError);

var _CourseEnrollmentDoesNotExistError = require('./errors/CourseEnrollmentDoesNotExistError');

var _CourseEnrollmentDoesNotExistError2 = _interopRequireDefault(_CourseEnrollmentDoesNotExistError);

var _CourseVisibility = require('./CourseVisibility');

var _CourseSubscriptionTiers = require('./CourseSubscriptionTiers');

var _QueryCoursesParamsNotValidError = require('./errors/QueryCoursesParamsNotValidError');

var _QueryCoursesParamsNotValidError2 = _interopRequireDefault(_QueryCoursesParamsNotValidError);

var _SectionDoesNotExistError = require('./errors/SectionDoesNotExistError');

var _SectionDoesNotExistError2 = _interopRequireDefault(_SectionDoesNotExistError);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DEFAULT_FETCH_ALL_LIMIT = 3000;
/**
 * CourseServiceClient
 * @param {Object} options options object input data and dependency injection
 * @param {Object} options.fetch change fetch method from whatwg-fetch (optional, default: whatwg-fetch)
 * @param {string} options.courseId saves entering courseId required for some methods
 * @param {string} options.protocol the http protocol of the service endpoint
 * @param {string} options.host the host of the service endpoint
 * @param {string} options.path the path of the service endpoint (optional)
 * @param {number} options.retries the number of times the client should retry on network error / service error (optional, default: 3)
 * @param {number} options.delayInSecs the delay between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional)
 * @param {string} options.region states the region of the service for signing (optional, default: eu-west-1)
 * @param {RequestMaker} options.requestMaker for overriding request making logic (optional, default: RequestMaker)
 * @throws {UrlConstructionError} when either options.protocol or options.host is missing
 */

var CourseServiceClient = function (_Client) {
  (0, _inherits3.default)(CourseServiceClient, _Client);

  function CourseServiceClient(fetch, options) {
    (0, _classCallCheck3.default)(this, CourseServiceClient);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CourseServiceClient.__proto__ || (0, _getPrototypeOf2.default)(CourseServiceClient)).call(this, fetch, options));

    _this.courseId = _this.options.courseId;
    return _this;
  }

  (0, _createClass3.default)(CourseServiceClient, [{
    key: 'createDraftObject',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee(_ref) {
        var type = _ref.type,
            object = _ref.object,
            position = _ref.position,
            courseId = _ref.courseId,
            id = _ref.id,
            region = _ref.region;
        var url, expectedResponses, body, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.validateMissingParams({
                  'course id': courseId
                });
                url = this.url + '/api/drafts/' + courseId + '/id/' + id;
                expectedResponses = [201, 404, 409];
                body = {
                  type: type,
                  object: object,
                  position: position
                };
                _context.next = 6;
                return this.requestMaker.makeRequest(url, {
                  method: 'PUT',
                  body: (0, _stringify2.default)(body),
                  region: region
                }, expectedResponses);

              case 6:
                response = _context.sent;

                if (!(response.status === 404)) {
                  _context.next = 9;
                  break;
                }

                throw new _DraftObjectDoesNotExistError2.default(courseId, object.parentId);

              case 9:
                if (!(response.status === 409)) {
                  _context.next = 11;
                  break;
                }

                throw new _DraftObjectConflictError2.default(courseId, id, object.parentId, 'create');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createDraftObject(_x) {
        return _ref2.apply(this, arguments);
      }

      return createDraftObject;
    }()
    /**
     * Creates draft course (requires content-creators group)
     * @param {Object} course
     * @param {string} course.id (suggested === courseId)
     * @param {string} courseId
     * @throws {MissingParamError} when course object is missing
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'createDraftCourse',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee2(course) {
        var courseId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.courseId;
        var region;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.validateMissingParams({
                  course: course
                });
                region = void 0;

                if (course.regions && course.regions.length > 0) {
                  region = course.regions[0];
                }

                _context2.next = 5;
                return this.createDraftObject({
                  type: 'course',
                  object: course,
                  courseId: courseId,
                  id: courseId,
                  region: region
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createDraftCourse(_x3) {
        return _ref3.apply(this, arguments);
      }

      return createDraftCourse;
    }()
    /**
     * Creates draft section (requires content-creators group)
     * @param {Object} section
     * @param {string} section.id
     * @param {Number} position to place in the parent's array of child ids
     * @param {string} courseId
     * @throws {MissingParamError} when section object is missing
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'createDraftSection',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee3(section, position) {
        var courseId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.courseId;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.validateMissingParams({
                  section: section
                });

                if (!(position === null || position === undefined)) {
                  _context3.next = 3;
                  break;
                }

                throw new _clientLibrary.MissingParamError('position');

              case 3:
                _context3.next = 5;
                return this.createDraftObject({
                  type: 'section',
                  object: section,
                  courseId: courseId,
                  id: section.id,
                  position: position
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createDraftSection(_x5, _x6) {
        return _ref4.apply(this, arguments);
      }

      return createDraftSection;
    }()
    /**
     * Creates draft content (requires content-creators group)
     * @param {Object} content
     * @param {string} content.id
     * @param {Number} position to place in the parent's array of child ids
     * @param {string} courseId
     * @throws {MissingParamError} when content object is missing
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'createDraftContent',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee4(content, position) {
        var courseId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.courseId;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.validateMissingParams({
                  content: content
                });

                if (!(position === null || position === undefined)) {
                  _context4.next = 3;
                  break;
                }

                throw new _clientLibrary.MissingParamError('position');

              case 3:
                _context4.next = 5;
                return this.createDraftObject({
                  type: 'content',
                  object: content,
                  courseId: courseId,
                  id: content.id,
                  position: position
                });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createDraftContent(_x8, _x9) {
        return _ref5.apply(this, arguments);
      }

      return createDraftContent;
    }()
    /**
     * Creates draft content module (requires content-creators group)
     * @param {Object} module
     * @param {string} module.id
     * @param {Number} position to place in the parent's array of child ids
     * @param {string} courseId
     * @throws {MissingParamError} when module object is missing
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'createDraftContentModule',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee5(module, position) {
        var courseId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.courseId;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.validateMissingParams({
                  module: module
                });

                if (!(position === null || position === undefined)) {
                  _context5.next = 3;
                  break;
                }

                throw new _clientLibrary.MissingParamError('position');

              case 3:
                _context5.next = 5;
                return this.createDraftObject({
                  type: 'module',
                  object: module,
                  courseId: courseId,
                  id: module.id,
                  position: position
                });

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createDraftContentModule(_x11, _x12) {
        return _ref6.apply(this, arguments);
      }

      return createDraftContentModule;
    }()
  }, {
    key: 'updateDraftObject',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee6(_ref7) {
        var type = _ref7.type,
            object = _ref7.object,
            courseId = _ref7.courseId,
            id = _ref7.id;
        var url, expectedResponses, body, response;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.validateMissingParams({
                  'course id': courseId
                });
                url = this.url + '/api/drafts/' + courseId + '/id/' + id;
                expectedResponses = [200, 404];
                body = {
                  object: object,
                  type: type
                };
                _context6.next = 6;
                return this.requestMaker.makeRequest(url, {
                  method: 'PATCH',
                  body: (0, _stringify2.default)(body)
                }, expectedResponses);

              case 6:
                response = _context6.sent;

                if (!(response.status === 404)) {
                  _context6.next = 9;
                  break;
                }

                throw new _DraftObjectDoesNotExistError2.default(courseId, object.id);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateDraftObject(_x13) {
        return _ref8.apply(this, arguments);
      }

      return updateDraftObject;
    }()
    /**
     * Updates draft course (requires content-creators group)
     * @param {Object} course
     * @param {string} courseId
     * @throws {MissingParamError} when course object is missing
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'updateDraftCourse',
    value: function () {
      var _ref9 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee7(course, courseId) {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.validateMissingParams({
                  course: course
                });
                _context7.next = 3;
                return this.updateDraftObject({
                  type: 'course',
                  object: course,
                  courseId: courseId,
                  id: courseId
                });

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateDraftCourse(_x14, _x15) {
        return _ref9.apply(this, arguments);
      }

      return updateDraftCourse;
    }()
    /**
     * Updates draft section (requires content-creators group)
     * @param {Object} section
     * @param {string} section.id
     * @param {string} courseId
     * @throws {MissingParamError} when section object is missing
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'updateDraftSection',
    value: function () {
      var _ref10 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee8(section) {
        var courseId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.courseId;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.validateMissingParams({
                  section: section
                });
                _context8.next = 3;
                return this.updateDraftObject({
                  type: 'section',
                  object: section,
                  courseId: courseId,
                  id: section.id
                });

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function updateDraftSection(_x17) {
        return _ref10.apply(this, arguments);
      }

      return updateDraftSection;
    }()
    /**
     * Updates draft content (requires content-creators group)
     * @param {Object} content
     * @param {string} content.id
     * @param {string} courseId
     * @throws {MissingParamError} when content object is missing
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'updateDraftContent',
    value: function () {
      var _ref11 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee9(content) {
        var courseId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.courseId;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.validateMissingParams({
                  content: content
                });
                _context9.next = 3;
                return this.updateDraftObject({
                  type: 'content',
                  object: content,
                  courseId: courseId,
                  id: content.id
                });

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateDraftContent(_x19) {
        return _ref11.apply(this, arguments);
      }

      return updateDraftContent;
    }()
    /**
     * Updates draft content module (requires content-creators group)
     * @param {Object} module
     * @param {string} module.id
     * @param {string} courseId
     * @throws {MissingParamError} when module object is missing
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'updateDraftContentModule',
    value: function () {
      var _ref12 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee10(module) {
        var courseId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.courseId;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.validateMissingParams({
                  module: module
                });
                _context10.next = 3;
                return this.updateDraftObject({
                  type: 'module',
                  object: module,
                  courseId: courseId,
                  id: module.id
                });

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateDraftContentModule(_x21) {
        return _ref12.apply(this, arguments);
      }

      return updateDraftContentModule;
    }()
    /**
     * Publishes draft course into live catalogue (requires content-admin group)
     * @param {string} courseId
     * @throws {PublishingErrors} when there are publishing errors
     * @throws {DraftDoesNotExistError} when draft does not exist
     * @throws {MissingParamError} when course id object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<Response>} this can be ignored, but maybe useful for logging
     */

  }, {
    key: 'publish',
    value: function () {
      var _ref13 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee11() {
        var courseId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.courseId;
        var expectedResponses, response, errors;
        return _regenerator2.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.validateMissingParams({
                  'course id': courseId
                });
                expectedResponses = [200, 409, 404];
                _context11.next = 4;
                return this.requestMaker.makeRequest(this.url + '/api/drafts/' + courseId + '/publish', {
                  method: 'PUT'
                }, expectedResponses);

              case 4:
                response = _context11.sent;

                if (!(response.status === 200)) {
                  _context11.next = 7;
                  break;
                }

                return _context11.abrupt('return');

              case 7:
                if (!(response.status === 409)) {
                  _context11.next = 10;
                  break;
                }

                errors = response.json.errors;
                throw new _PublishingErrors2.default(courseId, errors);

              case 10:
                if (!(response.status === 404)) {
                  _context11.next = 12;
                  break;
                }

                throw new _DraftDoesNotExistError2.default(courseId);

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function publish() {
        return _ref13.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: 'generateUrlWithParams',
    value: function generateUrlWithParams(_ref14) {
      var url = _ref14.url,
          limit = _ref14.limit,
          lastKey = _ref14.lastKey;

      var params = this._generatePagingQueryParams({
        limit: limit,
        lastKey: lastKey
      });

      if (params.length !== 0) {
        url += '?' + params.join('&');
      }

      return url;
    }
    /**
     * Fetch draft course (requires content-creators group)
     * @param {string} courseId courseId
     * @param {number} options.limit the limit of course objects to return in each pagination response
     * @throws {MissingParamError} when there is no course id
     * @throws {DraftDoesNotExistError} when draft does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<Draft>}
     */

  }, {
    key: 'fetchDraft',
    value: function () {
      var _ref15 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee12() {
        var courseId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.courseId;

        var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref16$limit = _ref16.limit,
            limit = _ref16$limit === undefined ? DEFAULT_FETCH_ALL_LIMIT : _ref16$limit;

        var baseUrl, course, sections, contents, contentModules, lastKey, url, expectedResponses, response, page;
        return _regenerator2.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.validateMissingParams({
                  'course id': courseId
                });
                baseUrl = this.url + '/api/drafts/' + courseId;
                course = void 0;
                sections = [];
                contents = [];
                contentModules = [];
                lastKey = undefined;

              case 7:
                url = this.generateUrlWithParams({
                  url: baseUrl,
                  limit: limit,
                  lastKey: lastKey
                });
                expectedResponses = [200, 404];
                _context12.next = 11;
                return this.requestMaker.makeRequest(url, {
                  method: 'GET'
                }, expectedResponses);

              case 11:
                response = _context12.sent;

                if (!(response.status === 404)) {
                  _context12.next = 14;
                  break;
                }

                throw new _DraftDoesNotExistError2.default(courseId);

              case 14:
                page = response.json;
                lastKey = page.lastKey;
                course = page.course;
                sections = sections.concat(page.sections);
                contents = contents.concat(page.contents);
                contentModules = contentModules.concat(page.contentModules);

              case 20:
                if (lastKey) {
                  _context12.next = 7;
                  break;
                }

              case 21:
                return _context12.abrupt('return', new _Draft2.default({
                  course: course,
                  sections: sections,
                  contents: contents,
                  contentModules: contentModules
                }));

              case 22:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function fetchDraft() {
        return _ref15.apply(this, arguments);
      }

      return fetchDraft;
    }()
    /**
     * Fetches a signed url for a course or section
     * @param {string} courseId the id of the course to fetch
     * @param {string} sectionId (optional) the id of the section to fetch
     */

  }, {
    key: 'fetchSignedUrl',
    value: function () {
      var _ref17 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee13() {
        var courseId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.courseId;
        var sectionId = arguments[1];
        var url, response, reason;
        return _regenerator2.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.validateMissingParams({
                  'course id': courseId
                });
                url = this.url + '/api/courses/' + courseId + '/signed-url';

                if (sectionId) {
                  url = url + '?sectionId=' + sectionId;
                }

                _context13.next = 5;
                return this.requestMaker.makeRequest(url, {
                  method: 'GET'
                }, [200, 403, 404]);

              case 5:
                response = _context13.sent;

                if (!(response.status === 403)) {
                  _context13.next = 9;
                  break;
                }

                reason = response.json.reason;
                return _context13.abrupt('return', this.throwSpecificInvalidSubscriptionError(reason));

              case 9:
                return _context13.abrupt('return', response);

              case 10:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function fetchSignedUrl() {
        return _ref17.apply(this, arguments);
      }

      return fetchSignedUrl;
    }()
    /**
     * Fetches a course
     * @param {string} courseId courseId
     * @throws {MissingParamError} when there is no course id
     * @throws {CourseDoesNotExistError} when course does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<Course>}
     */

  }, {
    key: 'fetchCourse',
    value: function () {
      var _ref18 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee14() {
        var courseId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.courseId;
        var signedUrlResponse, signedCourseUrl, expectedResponses, response;
        return _regenerator2.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.validateMissingParams({
                  'course id': courseId
                });
                _context14.next = 3;
                return this.fetchSignedUrl(courseId);

              case 3:
                signedUrlResponse = _context14.sent;

                if (!(signedUrlResponse.status === 404)) {
                  _context14.next = 6;
                  break;
                }

                throw new _CourseDoesNotExistError2.default(courseId);

              case 6:
                signedCourseUrl = signedUrlResponse.json.url;
                expectedResponses = [200, 404];
                _context14.next = 10;
                return this.requestMaker.makeRequest(signedCourseUrl, {
                  method: 'GET',
                  headers: {
                    correlationId: signedUrlResponse.headers.get('correlationId')
                  }
                }, expectedResponses);

              case 10:
                response = _context14.sent;

                if (!(response.status === 404)) {
                  _context14.next = 13;
                  break;
                }

                throw new _CourseDoesNotExistError2.default(courseId);

              case 13:
                return _context14.abrupt('return', response.json);

              case 14:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function fetchCourse() {
        return _ref18.apply(this, arguments);
      }

      return fetchCourse;
    }()
    /**
     * Queries courses with params
     * @param {Object} params
     * @param {string} params.query free-text query
     * @param {Object} params.filters Fields to match exactly. Object with category as keys and array of fields as values.
     * @param {Array<string>} params.aggregations Array of fields to aggregate on
     * @param {Array<string>} params.sort Array of fields to sort by (provide order with `:asc/desc` eg _score:desc)
     * @param {number} params.from pagination from index
     * @param {number} params.size max results returned
     * @param {Object} options
     * @param {boolean} options.noRegion pass no region header when making the request
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<Object>}
     */

  }, {
    key: 'queryCourses',
    value: function () {
      var _ref19 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee15() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var expectedResponses, response, body;
        return _regenerator2.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                expectedResponses = [200, 422];
                _context15.next = 3;
                return this.requestMaker.makeRequest(this.url + '/api/courses/queryCourses', {
                  method: 'POST',
                  body: (0, _stringify2.default)(params),
                  noRegion: options.noRegion
                }, expectedResponses);

              case 3:
                response = _context15.sent;

                if (!(response.status === 422)) {
                  _context15.next = 7;
                  break;
                }

                body = response.json;
                throw new _QueryCoursesParamsNotValidError2.default(body.pointer, body.reason);

              case 7:
                if (!(response.status === 200)) {
                  _context15.next = 9;
                  break;
                }

                return _context15.abrupt('return', response.json);

              case 9:
                throw new Error('Unexpected response: ' + response.status + ' ' + response.body);

              case 10:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function queryCourses() {
        return _ref19.apply(this, arguments);
      }

      return queryCourses;
    }()
    /**
     * Fetches suggested courses for user
     * @param {number} limit optional limit to number of courses to return
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<Object>}
     */

  }, {
    key: 'fetchSuggestedCourses',
    value: function () {
      var _ref20 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee16(limit) {
        var expectedResponses, url, response;
        return _regenerator2.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                expectedResponses = [200, 429];
                url = this.url + '/api/courses/suggestedCourses';

                if (limit) {
                  url = url + '?limit=' + limit;
                }

                _context16.next = 5;
                return this.requestMaker.makeRequest(url, {
                  method: 'GET'
                }, expectedResponses);

              case 5:
                response = _context16.sent;

                if (!(response.status === 429)) {
                  _context16.next = 8;
                  break;
                }

                throw new _clientLibrary.InvalidParamError('limit', limit, 'limit must be a number');

              case 8:
                if (!(response.status === 200)) {
                  _context16.next = 10;
                  break;
                }

                return _context16.abrupt('return', response.json);

              case 10:
                throw new Error('Unexpected response: ' + response.status + ' ' + response.body);

              case 11:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function fetchSuggestedCourses(_x29) {
        return _ref20.apply(this, arguments);
      }

      return fetchSuggestedCourses;
    }()
    /**
     * Fetches Leading Modules for a Course
     * @param {string} courseId courseId
     * @throws {MissingParamError} when there is no course id
     * @throws {CourseDoesNotExistError} when course does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<Course>}
     */

  }, {
    key: 'fetchLeadingModules',
    value: function () {
      var _ref21 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee17() {
        var courseId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.courseId;
        var expectedResponses, response;
        return _regenerator2.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.validateMissingParams({
                  'course id': courseId
                });
                expectedResponses = [200, 404];
                _context17.next = 4;
                return this.requestMaker.makeRequest(this.url + '/api/courses/' + courseId + '/leadingModules', {
                  method: 'GET'
                }, expectedResponses);

              case 4:
                response = _context17.sent;

                if (!(response.status === 200)) {
                  _context17.next = 7;
                  break;
                }

                return _context17.abrupt('return', response.json);

              case 7:
                if (!(response.status === 404)) {
                  _context17.next = 9;
                  break;
                }

                throw new _CourseDoesNotExistError2.default(courseId);

              case 9:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function fetchLeadingModules() {
        return _ref21.apply(this, arguments);
      }

      return fetchLeadingModules;
    }()
    /**
     * Fetches all sections details for a course, paging as needed to get the full list.
     * @param {string} courseId courseId
     * @throws {MissingParamError} when there is no course id
     * @throws {CourseDoesNotExistError} when course does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<SectionDetails>}
     */

  }, {
    key: 'fetchCourseSectionDetails',
    value: function () {
      var _ref22 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee18(courseId) {
        var _ref23 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref23$limit = _ref23.limit,
            limit = _ref23$limit === undefined ? DEFAULT_FETCH_ALL_LIMIT : _ref23$limit;

        var course, sections, lastKey, page;
        return _regenerator2.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                course = void 0;
                sections = [];
                lastKey = void 0;

              case 4:
                _context18.next = 6;
                return this.fetchPageOfCourseSectionDetails(courseId, {
                  limit: limit,
                  lastKey: lastKey
                });

              case 6:
                page = _context18.sent;
                course = page.course;
                sections = sections.concat(page.sections);
                lastKey = page.lastKey;

              case 10:
                if (lastKey) {
                  _context18.next = 4;
                  break;
                }

              case 11:
                return _context18.abrupt('return', {
                  course: course,
                  sections: sections
                });

              case 12:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function fetchCourseSectionDetails(_x32) {
        return _ref22.apply(this, arguments);
      }

      return fetchCourseSectionDetails;
    }()
    /**
     * Fetches a single page of section details
     * @param options
     * @param {Number} options.limit the number of details to return (optional, default: 100)
     * @param {Object} options.lastKey the key of the last item of the previous page, enables paging (option, default: null)
     * @throws {MissingParamError} when there is no course id
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<SectionDetails>}
     */

  }, {
    key: 'fetchPageOfCourseSectionDetails',
    value: function () {
      var _ref24 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee19(courseId) {
        var _ref25 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            limit = _ref25.limit,
            lastKey = _ref25.lastKey;

        var baseUrl, expectedResponses, url, response;
        return _regenerator2.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                baseUrl = this.url + '/api/courses/' + courseId + '/sections';
                expectedResponses = [200, 404];
                url = this.generateUrlWithParams({
                  url: baseUrl,
                  limit: limit,
                  lastKey: lastKey
                });
                _context19.next = 6;
                return this.requestMaker.makeRequest(url, {
                  method: 'GET'
                }, expectedResponses);

              case 6:
                response = _context19.sent;

                if (!(response.status === 404)) {
                  _context19.next = 9;
                  break;
                }

                throw new _CourseDoesNotExistError2.default(courseId);

              case 9:
                return _context19.abrupt('return', response.json);

              case 10:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function fetchPageOfCourseSectionDetails(_x34) {
        return _ref24.apply(this, arguments);
      }

      return fetchPageOfCourseSectionDetails;
    }()
    /**
     * Fetches a section of a course
     * @param {string} courseId the id of the course which contains the section
     * @param {string} sectionId the id of the section to fetch
     * @throws {MissingParamError} when there is no course id or section id
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<Section>}
     */

  }, {
    key: 'fetchSection',
    value: function () {
      var _ref26 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee20(courseId, sectionId) {
        var signedUrlResponse, signedSectionUrl, expectedResponses, response;
        return _regenerator2.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId,
                  sectionId: sectionId
                });
                _context20.next = 3;
                return this.fetchSignedUrl(courseId, sectionId);

              case 3:
                signedUrlResponse = _context20.sent;

                if (!(signedUrlResponse.status === 404)) {
                  _context20.next = 6;
                  break;
                }

                throw new _SectionDoesNotExistError2.default(courseId, sectionId);

              case 6:
                signedSectionUrl = signedUrlResponse.json.url;
                expectedResponses = [200, 404];
                _context20.next = 10;
                return this.requestMaker.makeRequest(signedSectionUrl, {
                  method: 'GET',
                  headers: {
                    correlationId: signedUrlResponse.headers.get('correlationId')
                  }
                }, expectedResponses);

              case 10:
                response = _context20.sent;

                if (!(response.status === 404)) {
                  _context20.next = 13;
                  break;
                }

                throw new _SectionDoesNotExistError2.default(courseId, sectionId);

              case 13:
                return _context20.abrupt('return', response.json);

              case 14:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function fetchSection(_x35, _x36) {
        return _ref26.apply(this, arguments);
      }

      return fetchSection;
    }()
    /**
     * Fetches all course details paging as needed to get the full list.
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<CourseDetails>}
     */

  }, {
    key: 'fetchCourseDetails',
    value: function () {
      var _ref27 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee21() {
        var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref28$limit = _ref28.limit,
            limit = _ref28$limit === undefined ? DEFAULT_FETCH_ALL_LIMIT : _ref28$limit,
            _ref28$maxVisibility = _ref28.maxVisibility,
            maxVisibility = _ref28$maxVisibility === undefined ? _CourseVisibility.COURSE_VISIBILITY.PUBLIC : _ref28$maxVisibility,
            region = _ref28.region;

        return _regenerator2.default.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt('return', this.fetchDetails('courses', {
                  limit: limit,
                  maxVisibility: maxVisibility,
                  region: region
                }, _CourseDetails2.default));

              case 1:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function fetchCourseDetails() {
        return _ref27.apply(this, arguments);
      }

      return fetchCourseDetails;
    }()
    /**
     * Fetches all draft details paging as needed to get the full list. (requires content-creators group)
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<CourseDetails>}
     */

  }, {
    key: 'fetchDraftDetails',
    value: function () {
      var _ref29 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee22() {
        var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref30$limit = _ref30.limit,
            limit = _ref30$limit === undefined ? DEFAULT_FETCH_ALL_LIMIT : _ref30$limit,
            _ref30$maxVisibility = _ref30.maxVisibility,
            maxVisibility = _ref30$maxVisibility === undefined ? _CourseVisibility.COURSE_VISIBILITY.PUBLIC : _ref30$maxVisibility,
            region = _ref30.region;

        return _regenerator2.default.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt('return', this.fetchDetails('drafts', {
                  limit: limit,
                  maxVisibility: maxVisibility,
                  region: region
                }, _CourseDetails2.default, undefined, undefined, undefined, 'courses'));

              case 1:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function fetchDraftDetails() {
        return _ref29.apply(this, arguments);
      }

      return fetchDraftDetails;
    }()
  }, {
    key: 'fetchDetails',
    value: function () {
      var _ref31 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee23(type) {
        var _ref32 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref32$limit = _ref32.limit,
            limit = _ref32$limit === undefined ? DEFAULT_FETCH_ALL_LIMIT : _ref32$limit,
            _ref32$maxVisibility = _ref32.maxVisibility,
            maxVisibility = _ref32$maxVisibility === undefined ? _CourseVisibility.COURSE_VISIBILITY.PUBLIC : _ref32$maxVisibility,
            region = _ref32.region;

        var Details = arguments[2];
        var courseId = arguments[3];
        var subType = arguments[4];

        var _ref33;

        var expectedResponses = arguments[5];
        var expectedType = arguments[6];
        var items, lastKey, page;
        return _regenerator2.default.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!expectedType) {
                  expectedType = subType || type;
                }

                items = [];
                lastKey = undefined;

              case 3:
                _context23.next = 5;
                return this.fetchPageOfDetails(type, {
                  limit: limit,
                  lastKey: lastKey,
                  maxVisibility: maxVisibility,
                  region: region
                }, Details, courseId, subType, expectedResponses);

              case 5:
                page = _context23.sent;
                lastKey = page.lastKey;
                items = items.concat(page[expectedType]);

              case 8:
                if (lastKey) {
                  _context23.next = 3;
                  break;
                }

              case 9:
                return _context23.abrupt('return', new Details((_ref33 = {}, (0, _defineProperty3.default)(_ref33, expectedType, items), (0, _defineProperty3.default)(_ref33, 'count', items.length), _ref33)));

              case 10:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function fetchDetails(_x40) {
        return _ref31.apply(this, arguments);
      }

      return fetchDetails;
    }()
    /**
     * Fetches a single page of course details
     * @param options
     * @param {Number} options.limit the number of details to return (optional, default: 100)
     * @param {Object} options.lastKey the key of the last item of the previous page, enables paging (option, default: null)
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<CourseDetails>}
     */

  }, {
    key: 'fetchPageOfCourseDetails',
    value: function () {
      var _ref34 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee24(options) {
        return _regenerator2.default.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt('return', this.fetchPageOfDetails('courses', options, _CourseDetails2.default));

              case 1:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function fetchPageOfCourseDetails(_x41) {
        return _ref34.apply(this, arguments);
      }

      return fetchPageOfCourseDetails;
    }()
    /**
     * Fetches a single page of draft details (requires content-creators group)
     * @param options
     * @param {Number} options.limit the number of details to return (optional, default: 100)
     * @param {Object} options.lastKey the key of the last item of the previous page, enables paging (option, default: null)
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<CourseDetails>}
     */

  }, {
    key: 'fetchPageOfDraftDetails',
    value: function () {
      var _ref35 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee25(options) {
        return _regenerator2.default.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt('return', this.fetchPageOfDetails('drafts', options, _CourseDetails2.default));

              case 1:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function fetchPageOfDraftDetails(_x42) {
        return _ref35.apply(this, arguments);
      }

      return fetchPageOfDraftDetails;
    }()
  }, {
    key: 'fetchPageOfDetails',
    value: function () {
      var _ref36 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee26(type, options, Details, courseId, subType) {
        var expectedResponses = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [200];
        var queryParamsParts, limit, queryParams, url, response, body;
        return _regenerator2.default.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                queryParamsParts = [];
                limit = 100;

                if (options && options.limit) {
                  limit = options.limit;
                }

                queryParamsParts.push('limit=' + limit);

                if (options && options.lastKey) {
                  queryParamsParts.push('lastKey=' + encodeURIComponent(options.lastKey));
                }

                if (options && options.maxVisibility) {
                  queryParamsParts.push('maxVisibility=' + encodeURIComponent(options.maxVisibility));
                }

                queryParams = queryParamsParts.join('&');
                url = this.url + '/api/' + type;

                if (courseId) {
                  url += '/' + courseId;
                }

                if (subType) {
                  url += '/' + subType;
                }

                _context26.next = 12;
                return this.requestMaker.makeRequest(url + '?' + queryParams, {
                  method: 'GET',
                  region: options && options.region
                }, expectedResponses);

              case 12:
                response = _context26.sent;

                if (!(response.status === 404)) {
                  _context26.next = 15;
                  break;
                }

                throw new _CourseDoesNotExistError2.default(courseId);

              case 15:
                if (!(response.status === 200)) {
                  _context26.next = 18;
                  break;
                }

                body = response.json;
                return _context26.abrupt('return', new Details(body));

              case 18:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function fetchPageOfDetails(_x44, _x45, _x46, _x47, _x48) {
        return _ref36.apply(this, arguments);
      }

      return fetchPageOfDetails;
    }()
    /**
     * Deletes draft course (requires content-admin group)
     * @param {string} courseId
     * @throws {MissingParamError} when a parameter is missing
     * @throws {DraftObjectDoesNotExistError} when the draft course does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     */

  }, {
    key: 'deleteDraftCourse',
    value: function () {
      var _ref37 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee27(courseId) {
        return _regenerator2.default.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                _context27.next = 3;
                return this._makeDraftRequest(courseId, null, null, 'DELETE', null, [204, 404]);

              case 3:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function deleteDraftCourse(_x49) {
        return _ref37.apply(this, arguments);
      }

      return deleteDraftCourse;
    }()
  }, {
    key: '_makeDraftRequest',
    value: function () {
      var _ref38 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee28(courseId, id, type, method, body, expectedResponses) {
        var url, response;
        return _regenerator2.default.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                url = this.url + '/api/drafts';

                if (courseId) {
                  url += '/' + courseId;
                }

                if (id) {
                  url += '/id/' + id;
                }

                if (type) {
                  url += '/' + type;
                }

                _context28.next = 6;
                return this.requestMaker.makeRequest(url, {
                  method: method,
                  body: body ? (0, _stringify2.default)(body) : undefined
                }, expectedResponses);

              case 6:
                response = _context28.sent;

                if (!(response.status === 404)) {
                  _context28.next = 9;
                  break;
                }

                throw new _DraftObjectDoesNotExistError2.default(courseId, id || courseId);

              case 9:
                if (!(response.status === 409)) {
                  _context28.next = 11;
                  break;
                }

                throw new _DraftObjectConflictError2.default(courseId, id, body.newParentId, type);

              case 11:
                if (!(response.status === 422)) {
                  _context28.next = 13;
                  break;
                }

                throw new _DraftBodyNotValidError2.default(body);

              case 13:
                return _context28.abrupt('return', response.json);

              case 14:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function _makeDraftRequest(_x50, _x51, _x52, _x53, _x54, _x55) {
        return _ref38.apply(this, arguments);
      }

      return _makeDraftRequest;
    }()
    /**
     * Moves a draft object (and its children) to a new location within a course (requires content-creators group)
     * @param {string} courseId
     * @param {string} id of the object to move
     * @param {string} newParentId - the id of the parent to move the object to
     * @param {number} position to place object within the array of ids in the new parent
     * @throws {MissingParamError} when a parameter is missing
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {DraftObjectConflictError} for an invalid operation
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<DraftObject>} the updated object after the move
     */

  }, {
    key: 'moveDraftObject',
    value: function () {
      var _ref39 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee29(courseId, id, newParentId, position) {
        return _regenerator2.default.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId,
                  id: id,
                  newParentId: newParentId
                });

                if (!(position === null || position === undefined)) {
                  _context29.next = 3;
                  break;
                }

                throw new _clientLibrary.MissingParamError('position');

              case 3:
                _context29.next = 5;
                return this._makeDraftRequest(courseId, id, 'move', 'POST', {
                  newParentId: newParentId,
                  position: position
                }, [200, 404, 409]);

              case 5:
                return _context29.abrupt('return', _context29.sent);

              case 6:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function moveDraftObject(_x56, _x57, _x58, _x59) {
        return _ref39.apply(this, arguments);
      }

      return moveDraftObject;
    }()
    /**
     * Deletes a draft object (and its children if they exist) (requires content-creators group)
     * @param {string} courseId
     * @param {string} id of the object to delete
     * @throws {MissingParamError} when a parameter is missing
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'deleteDraftObject',
    value: function () {
      var _ref40 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee30(courseId, id) {
        return _regenerator2.default.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId,
                  id: id
                });
                _context30.next = 3;
                return this._makeDraftRequest(courseId, id, null, 'DELETE', null, [200, 404]);

              case 3:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function deleteDraftObject(_x60, _x61) {
        return _ref40.apply(this, arguments);
      }

      return deleteDraftObject;
    }()
    /**
     * Batch imports (copies) multiple draft objects and their children to a new location in the
     * same course or a different course (requires content-creators group)
     * @param {Array<{courseId, id}>} srcKeys array of keys to import
     * @param {string} destCourseId the course id to import the objects to
     * @param {string} newParentId - the id of the parent to import the objects to
     * @param {number} position to place objects within the array of ids in the new parent
     * @throws {MissingParamError} when a parameter is missing
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {DraftObjectConflictError} for an invalid operation
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<DraftObject>} the updated object after the import
     */

  }, {
    key: 'batchImportDraftObjects',
    value: function () {
      var _ref41 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee31(srcKeys, destCourseId, newParentId, position) {
        return _regenerator2.default.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                this.validateMissingParams({
                  srcKeys: srcKeys,
                  destCourseId: destCourseId,
                  newParentId: newParentId
                });

                if (!(position === null || position === undefined)) {
                  _context31.next = 3;
                  break;
                }

                throw new _clientLibrary.MissingParamError('position');

              case 3:
                _context31.next = 5;
                return this._makeDraftRequest(null, null, 'import/batch', 'POST', {
                  srcKeys: srcKeys,
                  destCourseId: destCourseId,
                  newParentId: newParentId,
                  position: position
                }, [200, 404, 409]);

              case 5:
                return _context31.abrupt('return', _context31.sent);

              case 6:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function batchImportDraftObjects(_x62, _x63, _x64, _x65) {
        return _ref41.apply(this, arguments);
      }

      return batchImportDraftObjects;
    }()
    /**
     * Updates draft to the desired visibility (requires content-admin group)
     * @param {string} courseId the id of the course to update
     * @param {string<COURSE_VISIBILITY>} visibility the visibility to set the draft to
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<DraftObject>} the updated object after the visibility change
     */

  }, {
    key: 'updateDraftVisibility',
    value: function () {
      var _ref42 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee32(courseId, visibility) {
        return _regenerator2.default.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId,
                  visibility: visibility
                });
                return _context32.abrupt('return', this._makeDraftRequest(courseId, null, 'visibility', 'PATCH', {
                  visibility: visibility
                }, [200, 404, 422]));

              case 2:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function updateDraftVisibility(_x66, _x67) {
        return _ref42.apply(this, arguments);
      }

      return updateDraftVisibility;
    }()
    /**
     * Sets a draft to visibility: public (requires content-admin group)
     * @param {string} courseId the id of the course to update
     * @param {string<COURSE_VISIBILITY>} visibility the visibility to set the draft to
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<DraftObject>} the updated object after the visibility change
     */

  }, {
    key: 'makeDraftPublic',
    value: function () {
      var _ref43 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee33(courseId) {
        return _regenerator2.default.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                return _context33.abrupt('return', this.updateDraftVisibility(courseId, _CourseVisibility.COURSE_VISIBILITY.PUBLIC));

              case 2:
              case 'end':
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function makeDraftPublic(_x68) {
        return _ref43.apply(this, arguments);
      }

      return makeDraftPublic;
    }()
    /**
     * Sets a draft to visibility: hidden (requires content-admin group)
     * @param {string} courseId the id of the course to update
     * @param {string<COURSE_VISIBILITY>} visibility the visibility to set the draft to
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<DraftObject>} the updated object after the visibility change
     */

  }, {
    key: 'makeDraftHidden',
    value: function () {
      var _ref44 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee34(courseId) {
        return _regenerator2.default.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                return _context34.abrupt('return', this.updateDraftVisibility(courseId, _CourseVisibility.COURSE_VISIBILITY.HIDDEN));

              case 2:
              case 'end':
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function makeDraftHidden(_x69) {
        return _ref44.apply(this, arguments);
      }

      return makeDraftHidden;
    }()
    /**
     * Updates draft to the desired subscription tier (requires content-admin group)
     * @param {string} courseId the id of the course to update
     * @param {string<COURSE_SUBSCRIPTION_TIERS>} subscriptionTier the subscription tier to set the draft to
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<DraftObject>} the updated object after the subscription tier change
     */

  }, {
    key: 'updateDraftSubscriptionTier',
    value: function () {
      var _ref45 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee35(courseId, subscriptionTier) {
        return _regenerator2.default.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId,
                  subscriptionTier: subscriptionTier
                });
                return _context35.abrupt('return', this._makeDraftRequest(courseId, null, 'subscription-tier', 'PATCH', {
                  subscriptionTier: subscriptionTier
                }, [200, 404, 422]));

              case 2:
              case 'end':
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function updateDraftSubscriptionTier(_x70, _x71) {
        return _ref45.apply(this, arguments);
      }

      return updateDraftSubscriptionTier;
    }()
    /**
     * Sets a draft to subscriptionTier: free (requires content-admin group)
     * @param {string} courseId the id of the course to update
     * @param {string<COURSE_SUBSCRIPTION_TIERS>} subscriptionTier the subscription tier to set the draft to
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<DraftObject>} the updated object after the subscription tier change
     */

  }, {
    key: 'makeDraftSubscriptionFree',
    value: function () {
      var _ref46 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee36(courseId) {
        return _regenerator2.default.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                return _context36.abrupt('return', this.updateDraftSubscriptionTier(courseId, _CourseSubscriptionTiers.COURSE_SUBSCRIPTION_TIERS.FREE));

              case 2:
              case 'end':
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function makeDraftSubscriptionFree(_x72) {
        return _ref46.apply(this, arguments);
      }

      return makeDraftSubscriptionFree;
    }()
    /**
     * Sets a draft to subscriptionTier: premium (requires content-admin group)
     * @param {string} courseId the id of the course to update
     * @param {string<COURSE_SUBSCRIPTION_TIERS>} subscriptionTier the subscription tier to set the draft to
     * @throws {DraftObjectDoesNotExistError} when the draft object does not exist
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<DraftObject>} the updated object after the subscription tier change
     */

  }, {
    key: 'makeDraftSubscriptionPremium',
    value: function () {
      var _ref47 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee37(courseId) {
        return _regenerator2.default.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                return _context37.abrupt('return', this.updateDraftSubscriptionTier(courseId, _CourseSubscriptionTiers.COURSE_SUBSCRIPTION_TIERS.PREMIUM));

              case 2:
              case 'end':
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function makeDraftSubscriptionPremium(_x73) {
        return _ref47.apply(this, arguments);
      }

      return makeDraftSubscriptionPremium;
    }()
  }, {
    key: '_makeCourseEnrollmentRequest',
    value: function () {
      var _ref48 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee38(method, courseId, body, queryParams) {
        var url, queryParamParts, expectedResponses, response, _body, _body2, _body3;

        return _regenerator2.default.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                url = this.url + '/api/enrollments/me/courses';

                if (courseId) {
                  url += '/' + courseId;
                }

                if (queryParams && (0, _keys2.default)(queryParams).length > 0) {
                  queryParamParts = (0, _keys2.default)(queryParams).map(function (param) {
                    return encodeURIComponent(param) + '=' + encodeURIComponent(queryParams[param]);
                  });
                  url += '?' + queryParamParts.join('&');
                }

                expectedResponses = [200, 201, 204, 403, 404, 422];
                _context38.next = 6;
                return this.requestMaker.makeRequest(url, {
                  method: method,
                  body: body ? (0, _stringify2.default)(body) : undefined
                }, expectedResponses);

              case 6:
                response = _context38.sent;

                if (!(response.status === 403)) {
                  _context38.next = 10;
                  break;
                }

                _body = response.json;
                return _context38.abrupt('return', this.throwSpecificInvalidSubscriptionError(_body.reason));

              case 10:
                if (!(response.status === 404)) {
                  _context38.next = 12;
                  break;
                }

                throw new _CourseEnrollmentDoesNotExistError2.default(courseId);

              case 12:
                if (!(response.status === 422)) {
                  _context38.next = 15;
                  break;
                }

                _body2 = response.json;
                throw new _CourseEnrollmentBodyNotValidError2.default(_body2.pointer, _body2.reason);

              case 15:
                if (!(response.status === 200 || response.status === 201)) {
                  _context38.next = 18;
                  break;
                }

                _body3 = response.json;
                return _context38.abrupt('return', _body3.items ? new _CourseEnrollmentsPage2.default(_body3) : new _CourseEnrollment2.default(_body3));

              case 18:
              case 'end':
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function _makeCourseEnrollmentRequest(_x74, _x75, _x76, _x77) {
        return _ref48.apply(this, arguments);
      }

      return _makeCourseEnrollmentRequest;
    }()
    /**
     * Fetches all course enrollments for the current user paging as necessary to get them all.
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<[Enrollment]>} the enrollment object
     */

  }, {
    key: 'fetchUsersCourseEnrollments',
    value: function () {
      var _ref49 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee39() {
        var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref50$limit = _ref50.limit,
            limit = _ref50$limit === undefined ? DEFAULT_FETCH_ALL_LIMIT : _ref50$limit;

        var enrollments, lastKey, page;
        return _regenerator2.default.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                enrollments = [];
                lastKey = undefined;

              case 2:
                _context39.next = 4;
                return this.fetchPageOfUsersCourseEnrollments({
                  limit: limit,
                  lastKey: lastKey
                });

              case 4:
                page = _context39.sent;
                lastKey = page.lastKey;
                enrollments = enrollments.concat(page.items);

              case 7:
                if (lastKey) {
                  _context39.next = 2;
                  break;
                }

              case 8:
                return _context39.abrupt('return', enrollments);

              case 9:
              case 'end':
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function fetchUsersCourseEnrollments() {
        return _ref49.apply(this, arguments);
      }

      return fetchUsersCourseEnrollments;
    }()
    /**
     * Fetches a single page of course enrollments for the current user.
     * @param {Object} options - optional {limit, lastKey}
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<[EnrollmentPage]>} the enrollment object
     */

  }, {
    key: 'fetchPageOfUsersCourseEnrollments',
    value: function () {
      var _ref51 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee40(options) {
        var query;
        return _regenerator2.default.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                query = {};
                options.limit && (query.limit = options.limit);
                options.lastKey && (query.lastKey = options.lastKey);
                _context40.next = 5;
                return this._makeCourseEnrollmentRequest('GET', null, null, query);

              case 5:
                return _context40.abrupt('return', _context40.sent);

              case 6:
              case 'end':
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function fetchPageOfUsersCourseEnrollments(_x79) {
        return _ref51.apply(this, arguments);
      }

      return fetchPageOfUsersCourseEnrollments;
    }()
    /**
     * Fetches a single enrollment by course id for the current user
     * @param {string} courseId - the course id of the enrollment to fetch.
     * @throws {MissingParamError} when the courseId is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @throws {EnrollmentDoesNotExistError} when the enrollment cant be found.
     * @returns {Promise.<Enrollment>} the enrollment object
     */

  }, {
    key: 'fetchUsersCourseEnrollment',
    value: function () {
      var _ref52 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee41(courseId) {
        return _regenerator2.default.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                _context41.next = 3;
                return this._makeCourseEnrollmentRequest('GET', courseId, null);

              case 3:
                return _context41.abrupt('return', _context41.sent);

              case 4:
              case 'end':
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function fetchUsersCourseEnrollment(_x80) {
        return _ref52.apply(this, arguments);
      }

      return fetchUsersCourseEnrollment;
    }()
    /**
     * Creates a new course enrollment entry for the current user
     * @param {string} courseId
     * @throws {MissingParamError} when the enrollment object is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @throws {EnrollmentBodyNotValidError} when the enrollment payload was invalid and could not be updated
     * @returns {Promise.<Enrollment>} the new enrollment.
     */

  }, {
    key: 'enrollUserInCourse',
    value: function () {
      var _ref53 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee42(courseId) {
        return _regenerator2.default.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                _context42.next = 3;
                return this._makeCourseEnrollmentRequest('PUT', courseId, {
                  courseId: courseId
                });

              case 3:
                return _context42.abrupt('return', _context42.sent);

              case 4:
              case 'end':
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function enrollUserInCourse(_x81) {
        return _ref53.apply(this, arguments);
      }

      return enrollUserInCourse;
    }()
    /**
     * Deletes an existing enrollment for the current user
     * @param {string} courseId - the id of the enrollment to delete.
     * @throws {MissingParamError} when the courseId is missing
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @throws {EnrollmentDoesNotExistError} when the enrollment cant be found.
     * @returns {Promise.<undefined>}
     */

  }, {
    key: 'unenrollUserFromCourse',
    value: function () {
      var _ref54 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee43(courseId) {
        return _regenerator2.default.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                this.validateMissingParams({
                  courseId: courseId
                });
                _context43.next = 3;
                return this._makeCourseEnrollmentRequest('DELETE', courseId, null);

              case 3:
                return _context43.abrupt('return', _context43.sent);

              case 4:
              case 'end':
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function unenrollUserFromCourse(_x82) {
        return _ref54.apply(this, arguments);
      }

      return unenrollUserFromCourse;
    }()
  }, {
    key: 'throwSpecificInvalidSubscriptionError',
    value: function throwSpecificInvalidSubscriptionError(reason) {
      switch (reason) {
        case 'No subscription found':
          throw new _SubscriptionNotFoundError2.default(reason);

        case 'Subscription not active':
          throw new _SubscriptionNotActiveError2.default(reason);

        case 'Subscription not valid':
          throw new _SubscriptionNotValidError2.default(reason);

        default:
          throw new _SubscriptionNotValidError2.default(reason);
      }
    }
  }, {
    key: 'validateMissingParams',
    value: function validateMissingParams(args) {
      (0, _keys2.default)(args).forEach(function (argName) {
        if (!args[argName]) {
          throw new _clientLibrary.MissingParamError(argName);
        }
      });
    }
  }]);
  return CourseServiceClient;
}(_clientLibrary.Client);

exports.default = CourseServiceClient;